module.exports = __webpack_public_path__ + "static/media/gift_title.5e5ce100.png";